/* ============================================================================
   facil. — FAÇADE BUNDLE (cartes) → pilote le widget Simple Bundles caché.
   Lit les <select> de l'app (#simple-bundles-io-options), masque le widget,
   affiche des cartes images, et règle les <select> + dispatch change à chaque
   choix. L'ATC produit existant soumet le bundle (l'app écrit les properties).
   Vanilla, zéro lib. Robuste au chargement async du widget (poll + observer).
   ============================================================================ */
(function () {
  'use strict';
  if (window.__facilBundle) return;
  window.__facilBundle = true;

  var mount = document.querySelector('[data-facil-bundle]');
  if (!mount) return;

  var MODELS = {};
  try { MODELS = JSON.parse(document.querySelector('[data-facil-bundle-models]').textContent); } catch (e) {}

  var grid = mount.querySelector('[data-fb-grid]');
  var counterN = mount.querySelector('[data-fb-n]');
  var counterTotal = mount.querySelector('[data-fb-total]');
  var helpEl = mount.querySelector('[data-fb-help]');
  var atc = document.querySelector('[data-pdp-submit]');

  var selects = [], count = 0, pool = [], selections = [], started = false;
  var appContainer = null, appForm = null; // widget de l'app + son <form> /cart/add

  function modelKey(v) { return v.split(' - ')[0].replace(/\.\s*$/, '').trim().toUpperCase(); }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function findSelects() {
    var c = document.querySelector('#simple-bundles-io-options');
    if (!c) return null;
    var s = Array.prototype.slice.call(c.querySelectorAll('select'));
    return s.length ? s : null;
  }

  // Options réelles d'un <select> (on ignore le placeholder vide).
  function realOptions(s) {
    return Array.prototype.slice.call(s.options).filter(function (o) { return o.value; });
  }

  function init() {
    if (started) return true;
    var all = findSelects();
    if (!all) return false;

    // Un bundle peut MÉLANGER des composants FIXES (1 seule option, ex. la trousse) et de VRAIS
    // CHOIX (plusieurs options, ex. « choisis ton style »). On ne compte que les vrais choix ;
    // les fixes sont sélectionnés automatiquement pour que l'app reçoive une valeur valide.
    // → la façade marche pour n'importe quelle structure de bundle, pas seulement « N fois la même liste ».
    var fixed = [], choices = [];
    all.forEach(function (s) { (realOptions(s).length > 1 ? choices : fixed).push(s); });
    if (!choices.length) return false; // aucun choix réel → on laisse le widget natif de l'app

    fixed.forEach(function (s) {
      var o = realOptions(s)[0];
      if (o && s.value !== o.value) {
        s.value = o.value;
        s.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    started = true;
    selects = choices;
    count = choices.length;
    pool = realOptions(choices[0]).map(function (o) { return { value: o.value, label: o.textContent.trim() }; });

    var appWrap = document.querySelector('[data-simple-bundles-options]') || document.querySelector('#simple-bundles-io-options');
    if (appWrap) appWrap.classList.add('facil-bundle__hidden-app');
    all.forEach(function (s) { s.required = false; }); // évite l'erreur "hidden required" au submit

    // Références pour synchroniser le champ décisif de l'app (voir syncApp).
    appContainer = document.querySelector('#simple-bundles-io-options') || appWrap;
    appForm = (appContainer && appContainer.closest('form')) || document.querySelector('form[action*="/cart/add"]');

    buildCards();
    if (counterTotal) counterTotal.textContent = count;

    // Modèles dispo du kit (clés) → lus par le mini-diagnostic pour contraindre sa reco.
    var pmk = {};
    pool.forEach(function (o) { pmk[modelKey(o.value)] = 1; });
    mount.setAttribute('data-fb-models', Object.keys(pmk).join(','));

    // Le mini-diagnostic recommande un modèle → on l'ajoute au kit.
    document.addEventListener('facil:kit-pick', function (e) {
      var key = e.detail && e.detail.model;
      if (!key) return;
      for (var i = 0; i < pool.length; i++) {
        if (modelKey(pool[i].value) === key) { addBox(pool[i].value); break; }
      }
    });

    mount.classList.add('is-ready');
    render();
    return true;
  }

  function buildCards() {
    grid.innerHTML = '';
    pool.forEach(function (opt) {
      var mk = modelKey(opt.value);
      var m = MODELS[mk] || {};
      var name = m.name || opt.label.toLowerCase();

      var cell = document.createElement('div');
      cell.className = 'facil-bundle__cell';
      cell.setAttribute('data-fb-cell', opt.value);

      // LISTE COMPACTE, sans vignette (demande cliente) : le catalogue va s'allonger avec les
      // nouvelles collections, une grille d'images deviendrait interminable. Les photos restent
      // consultables via « voir » (pop-up galerie).
      cell.innerHTML =
        '<button type="button" class="facil-bundle__pick" data-fb-pick>' +
        '<span class="facil-bundle__name model">' + escapeHtml(name) + '</span>' +
        (m.edition ? '<span class="facil-bundle__badge">Édition limitée</span>' : '') +
        '</button>' +
        '<button type="button" class="facil-bundle__more" data-fb-more aria-label="Voir les images de ' + escapeHtml(name) + '">voir</button>' +
        '<div class="facil-bundle__stepper" data-fb-stepper hidden>' +
        '<button type="button" class="facil-bundle__step" data-fb-minus aria-label="Retirer">&minus;</button>' +
        '<span class="facil-bundle__stepn" data-fb-stepn>0</span>' +
        '<button type="button" class="facil-bundle__step" data-fb-plus aria-label="Ajouter">+</button></div>';

      cell.querySelector('[data-fb-pick]').addEventListener('click', function () { addBox(opt.value); });
      cell.querySelector('[data-fb-plus]').addEventListener('click', function (e) { e.stopPropagation(); addBox(opt.value); });
      cell.querySelector('[data-fb-minus]').addEventListener('click', function (e) { e.stopPropagation(); removeBox(opt.value); });
      cell.querySelector('[data-fb-more]').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openPopup(mk); });

      grid.appendChild(cell);
    });
  }

  function qtyOf(v) { var n = 0; selections.forEach(function (x) { if (x === v) n++; }); return n; }
  function addBox(v) { if (selections.length >= count) return; selections.push(v); render(); }
  function removeBox(v) { for (var i = selections.length - 1; i >= 0; i--) { if (selections[i] === v) { selections.splice(i, 1); break; } } render(); }

  function render() {
    Array.prototype.slice.call(grid.querySelectorAll('[data-fb-cell]')).forEach(function (cell) {
      var v = cell.getAttribute('data-fb-cell');
      var q = qtyOf(v);
      cell.classList.toggle('is-selected', q > 0);
      var step = cell.querySelector('[data-fb-stepper]'); if (step) step.hidden = q === 0;
      var sn = cell.querySelector('[data-fb-stepn]'); if (sn) sn.textContent = q;
    });
    if (counterN) counterN.textContent = selections.length;
    var rem = count - selections.length;
    if (helpEl) helpEl.textContent = rem > 0 ? ('Choisis encore ' + rem + ' boîte' + (rem > 1 ? 's' : '')) : '';

    // pilote les <select> de l'app (ordre = boîtes 1..N)
    for (var i = 0; i < count; i++) {
      var val = selections[i] || '';
      if (selects[i].value !== val) {
        selects[i].value = val;
        selects[i].dispatchEvent(new Event('input', { bubbles: true }));
        selects[i].dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    syncApp();
    if (atc) { var done = selections.length === count && count > 0; atc.disabled = !done; atc.classList.toggle('facil-bundle__atc-off', !done); }
  }

  // Reconstruit le champ caché « properties[_bundle_selection] » : c'est LUI que l'app lit
  // pour déterminer les VRAIS SKU expédiés (sinon elle prend le 1er produit de chaque boîte
  // = marron). L'app ne le régénère que sur une vraie interaction ; notre pilotage des <select>
  // par code ne le déclenche pas → on le fait nous-mêmes, dans l'ORDRE des boîtes de l'app.
  function syncApp() {
    if (!appContainer || !appForm) return;
    var allSelects = Array.prototype.slice.call(appContainer.querySelectorAll('select'));
    if (!allSelects.length) return;
    var parts = [];
    allSelects.forEach(function (s) {
      parts.push(s.value);
      // Miroir caché éventuel (même name) créé par l'app → gardé synchro.
      Array.prototype.forEach.call(appForm.elements, function (e) {
        if (e !== s && e.name === s.name && e.type === 'hidden') e.value = s.value;
      });
    });
    var bs = null;
    Array.prototype.forEach.call(appForm.elements, function (e) {
      if (e.name === 'properties[_bundle_selection]') bs = e;
    });
    if (!bs) {
      bs = document.createElement('input');
      bs.type = 'hidden';
      bs.name = 'properties[_bundle_selection]';
      appForm.appendChild(bs);
    }
    bs.value = parts.join(' <> ');
  }

  /* ---- Popup galerie ---- */
  var popup = mount.querySelector('[data-fb-popup]');
  var stage = mount.querySelector('[data-fb-stage]');
  var pname = mount.querySelector('[data-fb-pname]');
  var pmini = mount.querySelector('[data-fb-pmini]');
  var pcount = mount.querySelector('[data-fb-pcount]');
  var gimgs = [], gidx = 0;
  function openPopup(mk) { var m = MODELS[mk]; if (!m || !popup) return; gimgs = m.images || []; gidx = 0; if (pname) pname.textContent = m.name || ''; if (pmini) pmini.textContent = m.mini || ''; paint(); popup.hidden = false; document.documentElement.style.overflow = 'hidden'; }
  function paint() {
    if (!stage) return;
    // 1 seule image : pas de flèches, pas de compteur (dégradation propre).
    var multi = gimgs.length > 1;
    if (pv) pv.hidden = !multi;
    if (nx) nx.hidden = !multi;
    if (!gimgs.length) { stage.innerHTML = '<span class="facil-bundle__popup-empty">Visuel à venir</span>'; if (pcount) pcount.textContent = ''; return; }
    stage.innerHTML = '<img src="' + gimgs[gidx] + '" alt="">';
    if (pcount) pcount.textContent = multi ? ((gidx + 1) + ' / ' + gimgs.length) : '';
  }
  function move(d) { if (!gimgs.length) return; gidx = (gidx + d + gimgs.length) % gimgs.length; paint(); }
  function closePopup() { if (popup) popup.hidden = true; document.documentElement.style.overflow = ''; }
  if (popup) {
    var pv = mount.querySelector('[data-fb-prev]'); if (pv) pv.addEventListener('click', function () { move(-1); });
    var nx = mount.querySelector('[data-fb-next]'); if (nx) nx.addEventListener('click', function () { move(1); });
    /* Fermeture en DÉLÉGATION sur document : robuste même si le markup est réinjecté ou si
       un élément intercepte le clic. Couvre la croix ET l'overlay ([data-fb-close] sur les deux). */
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('[data-fb-close]')) return;
      e.preventDefault();
      closePopup();
    });
    document.addEventListener('keydown', function (e) { if (popup.hidden) return; if (e.key === 'Escape') closePopup(); else if (e.key === 'ArrowLeft') move(-1); else if (e.key === 'ArrowRight') move(1); });
  }

  /* ---- Attendre le widget async de l'app ---- */
  if (!init()) {
    var tries = 0;
    var iv = setInterval(function () { tries++; if (init() || tries > 40) clearInterval(iv); }, 250);
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { if (init()) mo.disconnect(); });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }
})();
